import BackButtonLayout from "core/layouts/backButtonLayout";
/* eslint-disable react/prop-types */
import React, { useContext, useState } from "react";
import { withRouter, useHistory, RouteComponentProps } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import AttachmentIcon from "@material-ui/icons/Attachment";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Context from "core/context/context";
import { ErrorComponent } from "core/components/Error";
import { isEmail } from "core/utils/patterns";
import { DescreptionText } from "core/components/text/descreptionText";
import { useStyles } from "./styles";

const win: any = window;
//const token = 'bdb50c03-aa40-4862-b275-4f63e96aa696';
const store_order_status_url = win["STORE_TRACK_ORDER_URL"]
  ? win["STORE_TRACK_ORDER_URL"]
  : "/wps/portal/web/personal/store/track-order";
let urlParams = new URLSearchParams(window.location.search);
let oId: any = urlParams.get("oId");

type Inputs = {
  orderid: string;
  email: string;
};
interface Props {
  step?: number;
}
const viewReqStatus = () => {
  console.log("Track order inquiry initiated.");
  win.open(win.viewRequestUrl);
};
const OrderSearch = (
  props: React.PropsWithChildren<Props & RouteComponentProps>
) => {
  const { t, i18n } = useTranslation();
  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const history = useHistory();
  const context = useContext(Context);
  const classes = useStyles();
  const theme = useTheme();
  const { register, handleSubmit, watch, errors, control } = useForm<Inputs>();
  const { orderid, email } = watch();

  const onSubmit = (data: Inputs) => {
    console.log(data);
    //window.sessionStorage.orderNumber = data.orderid;
    //window.sessionStorage.cusotmerEmail = data.email;

    localStorage.setItem("orderNumber", data.orderid);
    localStorage.setItem("cusotmerEmail", data.email);

    !!store_order_status_url &&
      (document.location.href = store_order_status_url);
  };
  return (
    <BackButtonLayout>
      <Grid container direction="column">
        {/* {!isRTL ? (
          <ArrowBackIcon
            onClick={() => history.goBack()}
            style={{ color: "#008CFF", cursor: "pointer" }}
            fontWeight={"fontWeightBold"}
            fontSize={"large"}
          />
        ) : (
          <ArrowForwardIcon
            onClick={() => history.goBack()}
            style={{ color: "#008CFF", cursor: "pointer" }}
            fontWeight={"fontWeightBold"}
            fontSize={"large"}
          />
        )} */}

        <Grid item sm={6} xs={12}>
          <Typography component={"span"} variant={"body2"}>
            <Box
              fontWeight={500}
              style={{
                direction: langDir,
              }}
              color={"#000000"}
              width={"100%"}
              fontSize={theme.spacing(4)}
              mb={theme.spacing(0.7)}
              mt={theme.spacing(0.4)}
              letterSpacing={1}
            >
              {t("PleasefillInformation")}
            </Box>
          </Typography>
        </Grid>
        <DescreptionText
          style={{
            fontSize: theme.spacing(2),
            direction: langDir,
            width: theme.spacing(39),
          }}
          text={t("FindOrderHint")}
        ></DescreptionText>
      </Grid>
      <div style={{ width: "30%" }}>
        <Typography>
          {t("portInRequest")}
          <a style={{ color: "green" }} href="" onClick={viewReqStatus}>
            {t("seeReqStatus")}
          </a>
        </Typography>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row style={{ marginTop: theme.spacing(5) }}>
          <RowItem style={{ width: "calc(50% - 7.5px)" }}>
            <Controller
              as={TextField}
              defaultValue={oId ? oId : ""}
              control={control}
              name="orderid"
              type={"string"}
              fullWidth
              InputLabelProps={{ shrink: true }}
              rules={{ required: true, maxLength: 50, minLength: 6 }}
              label={t("orderid")}
              id="orderid"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={50}
              minLength={6}
              patternMessage={t("orderid")}
              errors={errors}
              name={"orderid"}
            ></ErrorComponent>
          </RowItem>
        </Row>
        <Row style={{ marginTop: theme.spacing(1) }}>
          <RowItem style={{ width: "calc(50% - 7.5px)" }}>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="email"
              type={"string"}
              fullWidth
              InputLabelProps={{ shrink: true }}
              rules={{
                required: true,
                maxLength: 50,
                minLength: 6,
                pattern: isEmail,
              }}
              label={t("email")}
              id="email"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={50}
              minLength={6}
              patternMessage={t("emailPatternError")}
              errors={errors}
              name={"email"}
            ></ErrorComponent>
          </RowItem>
        </Row>

        <Grid>
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            className={classes.button}
            disabled={!orderid || !email}
            endIcon={
              isRTL ? (
                <ArrowBackIcon
                  style={{ color: "#fff", cursor: "pointer" }}
                  fontSize={"default"}
                />
              ) : (
                <ArrowForwardIcon
                  style={{ color: "#fff", cursor: "pointer" }}
                  fontSize={"default"}
                />
              )
            }
          >
            <Box mr={8} color={"white"}>
              {t("next")}
            </Box>
          </Button>
        </Grid>
      </form>
    </BackButtonLayout>
  );
};
export default withRouter(OrderSearch);

const Row = ({ children, ...rest }: any) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      style={{ display: "flex", justifyContent: "space-between" }}
      className={classes.rowContainer}
      {...rest}
    >
      {children}
    </Grid>
  );
};

const RowItem = ({ children, className, ...rest }: any) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Grid
      item
      className={className ? [className, classes.item] : classes.item}
      {...rest}
    >
      <Box mb={theme.spacing(0.2)} className={classes.input} component={"div"}>
        {children}
      </Box>
    </Grid>
  );
};
